import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Imgs } from "../../img/Imgs/Imgs";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";

const ServicesItem = () => {
  const selectedLanguages = useSelector(selectedLanguage);

  return (
    <section className="services">
      <div className="services__container container">
        <div className="services__context">
          <div className="services__context-info">
            <h3>{translations[selectedLanguages].services.firstItemTitle}</h3>
            <p>{translations[selectedLanguages].services.firstItemContext}</p>
            <Link to="/contact">
              {translations[selectedLanguages].services.button}
            </Link>
          </div>
          <img src={Imgs.servicefirstimg} alt="serviceimg" />
        </div>
        <div className="services__context">
          <img src={Imgs.servicesecondimg} alt="serviceimg" />
          <div className="services__context-info">
            <h3>{translations[selectedLanguages].services.secondItemTitle}</h3>
            <p>{translations[selectedLanguages].services.secondItemContext}</p>
            <Link to="/contact">
              {translations[selectedLanguages].services.button}
            </Link>
          </div>
        </div>
        <div className="services__context">
          <div className="services__context-info">
            <h3>{translations[selectedLanguages].services.thirdItemTitle}</h3>
            <p>{translations[selectedLanguages].services.thirdItemContext}</p>
            <Link to="/contact">
              {translations[selectedLanguages].services.button}
            </Link>
          </div>
          <img src={Imgs.servicethirdimg} alt="serviceimg" />
        </div>
      </div>
    </section>
  );
};

export default ServicesItem;
